import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export type ProductGroupItem = Omit<ProductGroupInternalItem, 'version'>;

type ProductGroupInternalItem = {
    readonly version: string;
    readonly externalId: string;
    readonly isDefault: boolean;
    readonly name: string;
};

export class ProductGroupCollectionQuery extends Query<ProductGroupItem[]> { }

export class ProductGroupCollectionQueryHandlerBase implements QueryHandler<ProductGroupCollectionQuery, ProductGroupItem[]> {
    private static Url = TaggedUrl.join('products/groups', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: ProductGroupCollectionQuery): Promise<ProductGroupItem[]> {
        const { data } = await this.http.get<ProductGroupInternalItem[]>(ProductGroupCollectionQueryHandlerBase.Url, {
            params: {
                isDeleted: false
            }
        });
        return data.map(item => ({
            externalId: item.externalId,
            isDefault: item.isDefault,
            name: item.name
        }));
    }
}
